module.exports = __webpack_public_path__ + "static/media/SF_nn_sekundaerlogo_postale_moere_og_romsdal_pos.028646c4.png";